<template>
    <div>
        <v-navigation-drawer 
            v-model="drawer" 
            app
            floating
            :permanent="drawer"
            :mini-variant="mini"
            width="350px"
        >
            <v-tabs
                v-model="tab"
                background-color="primary"
                vertical
                dark
                class="line-sidebar"
            >
                <div class="logo accent">
                    <img src="@/assets/logo-nav.png" style="width: 50%;" class="ma-auto" alt="logo">
                </div>

                <v-tab href="#Home" @click="changeView('Home')">
                    <v-icon>mdi-home</v-icon>
                </v-tab>

                <v-tab href="#Plant" @click="changeView('Plant')">
                    <v-icon>mdi-resistor</v-icon>
                </v-tab>

                <v-spacer></v-spacer>

                <div class="d-none d-md-flex">
                    <userMenu class="ma-auto"/>
                </div>
            </v-tabs>

            <v-tabs-items v-model="tab">
                <v-tab-item :value="'Plant' || 'Map'" class="h-100">
                    <v-card  flat class="h-100">
                        <div class="title">
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Puntos de medición
                                    </v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-icon >
                                    <v-btn icon @click="mini = !mini" class="d-none d-md-block">
                                        <v-icon>mdi-chevron-left</v-icon>
                                    </v-btn>
                                    <v-btn icon @click="updateStateDrawer(false)" class="d-md-none">
                                        <v-icon>mdi-chevron-left</v-icon>
                                    </v-btn>
                                </v-list-item-icon>
                            </v-list-item>
                            <v-divider></v-divider>
                            <v-text-field
                                v-model="filter_plants.filter"
                                clearable
                                solo
                                outlined
                                dense
                                flat
                                hide-details
                                prepend-inner-icon="mdi-magnify"
                                class="mx-3 mt-3"
                                @keypress="filterPlants"
                                style="font-size:12px"
                            ></v-text-field>
                            <div class="pa-0 text-center">
                                <v-chip x-small color="accent" label dark @click="filterStatus('accent', 'Conectado')">
                                    Conectado
                                </v-chip>
                                <v-chip x-small color="yellow accent-4" label dark class="mx-4" @click="filterStatus('yellow accent-4', 'Alerta')">
                                    Alerta
                                </v-chip>
                                <v-chip x-small color="red darken-3" label dark @click="filterStatus('red darken-3', 'Desconectado')">
                                    Desconectado
                                </v-chip>
                            </div>
                        </div>
                        <v-card-text class="pa-0 list-body">
                            <v-list  flat dense three-line>
                                <v-list-item-group v-if="filter_plants.filter === '' || filter_plants.filter === null">
                                    <v-divider></v-divider>
                                    <template v-for="(plant, index) in gateways">
                                        <v-list-item 
                                            :key="plant.id" 
                                            color="primary"
                                            active-class="active-plant"
                                            @click="selectGateway(plant.id)">

                                            <v-list-item-avatar 
                                                class="mt-5"
                                                size="25"
                                                :color="colorStatus.find( g => g.id === plant.id) 
                                                    ? colorStatus.find( g => g.id === plant.id).color
                                                    : 'blue-grey darken-1' "
                                            >
                                                <v-icon small color="white">mdi-resistor</v-icon>
                                            </v-list-item-avatar>

                                            <v-list-item-content>
                                                <v-list-item-title class="name-plant">{{ plant.name }}</v-list-item-title>
                                                <v-list-item-subtitle style="margin-top: -10px;">{{ plant.description }}</v-list-item-subtitle>
                                            </v-list-item-content>

                                        </v-list-item>
                                        <v-divider :key="index" class="ma-0"></v-divider>
                                    </template>
                                </v-list-item-group>
                                <v-list-item-group v-else>
                                    <v-divider></v-divider>
                                    <template v-for="(plant, index) in filter_plants.data">
                                        <v-list-item 
                                            :key="plant.id" 
                                            color="primary"
                                            active-class="active-plant"
                                            @click="selectGateway(plant.id)">

                                            <v-list-item-avatar
                                                class="mt-5"
                                                size="25"
                                                :color="colorStatus.find( g => g.id === plant.id) 
                                                    ? colorStatus.find( g => g.id === plant.id).color
                                                    : 'blue-grey darken-1' "
                                            >
                                                <v-icon small color="white">mdi-resistor</v-icon>
                                            </v-list-item-avatar>

                                            <v-list-item-content>
                                                <v-list-item-title class="name-plant">{{ plant.name }}</v-list-item-title>
                                                <v-list-item-subtitle>{{ plant.description }}</v-list-item-subtitle>
                                            </v-list-item-content>

                                        </v-list-item>
                                        <v-divider :key="index" class="ma-0"></v-divider>
                                    </template>
                                </v-list-item-group>
                            </v-list>
                        </v-card-text>
                        <div class="buttons-action pa-2" v-if="!mini">
                            <v-btn v-if="view == 'Plant'" class="mb-3" block color="accent" @click="changeView('Map')">
                                <v-spacer>Ver mapa</v-spacer> <v-icon>mdi-map-marker</v-icon>
                            </v-btn>
                            <v-btn v-else-if="view == 'Map'" class="mb-3" block color="accent" @click="changeView('Plant')">
                                <v-spacer>Ver dashboard</v-spacer> <v-icon>mdi-view-dashboard</v-icon>
                            </v-btn>
                            <v-btn color="accent" block @click="actionNew" v-if="userAtLeastIs(user, LEVEL_ADMIN)">
                                <v-spacer>Añadir nuevo</v-spacer> <v-icon>mdi-plus-circle</v-icon>
                            </v-btn>
                        </div>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </v-navigation-drawer>

        <formGateway 
            :open="gtw_form.open" 
            @close="actionClose" 
            :id="gtw_form.id"/>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { LEVEL_ADMIN, userAtLeastIs } from '../../plugins/checkPermission'
import userMenu from './user-menu'
import formGateway from '../formGateway'

export default {
    name: 'sidebar',
    props: ['drawer'],
    computed: {
        ...mapState({
            user: state => state.user.profile.level,
            gateways: state => state.gateways.list,
            selected: state => state.gateways.selected,
            view: state => state.user.view,
            lastReadings: state => state.meters.lastReadings,
            minutesToWarn: state => state.account.profile.minutesToWarn,
            minutesToDanger: state => state.account.profile.minutesToDanger,
            colorStatus(){
                if(this.gateways === null || this.lastReadings === null) 
                    return []
                
                const gateways = this.gateways.map( g => {
                    const reads = this.lastReadings.filter( read => g.id === read.gateway )
                    if(reads.length === 0) return { id: g.id, color: 'blue-grey darken-1' }

                    let last = null
                    reads.forEach( read => {
                        if(!last || last.data.updated.getTime() < read.data.updated.getTime() )
                            last = read
                    });
                    
                    const now = new Date().getTime()
                    const lastTime = last.data.updated.getTime()
                    if(now - lastTime > this.minutesToDanger * 1000 * 60)
                        return { id: g.id, color: 'red darken-3' }
                    else if(now - lastTime > this.minutesToWarn * 1000 * 60)
                        return { id: g.id, color: 'yellow accent-4' }
                    return { id: g.id, color: 'accent' }
                } )
                
                return gateways
            }
        })
    },
    components: { formGateway, userMenu },
    data() {
        return {
            mini: false,
            tab: null,
            filter_plants: {
                data: [],
                filter: ''
            },
            gtw_form:{
                open: false,
                id: null
            },
            LEVEL_ADMIN
        }
    },
    methods: {
        ...mapActions({ 
            updateSelected: 'gateways/updatedGatewaySelected'
        }),
        userAtLeastIs,
        selectGateway(id){
            if(this.selected === id) {
                this.updateSelected(null)
                return
            }
            this.updateSelected(id)
        },
        changeView(view){
            if(view === this.view) return
            this.$router.push({ name: view })
        },
        updateStateDrawer(value) {
            this.$emit('update-drawer', value)
        },
        actionNew(){
            switch (this.tab) {
                case 'Plant':
                    this.gtw_form.open = true
                    break;

                default:
                    break;
            }
        },
        actionClose(){
            switch (this.tab) {
                case 'Plant':
                    this.gtw_form.id = null
                    this.gtw_form.open = false
                    break

                default:
                    break
            }
        },
        filterStatus(color, text){
            this.filter_plants.filter = text
            const data = this.colorStatus.filter( p => p.color === color )
            this.filter_plants.data = this.gateways.filter( plant => data.find(p => p.id == plant.id) )
        },
        filterPlants(){
            this.filter_plants.data = this.gateways.filter( p =>
                p.name
                    .toLowerCase()
                    .indexOf(this.filter_plants.filter.toLowerCase()) > -1 ||
                p.description
                    .toLowerCase()
                    .indexOf(this.filter_plants.filter.toLowerCase()) > -1
            )
        },
        setTabValue(){
            const { expandSidebar } = this.$route.meta
            this.mini = expandSidebar !== true
            
            const { smAndDown } = this.$vuetify.breakpoint
            if(smAndDown) this.$emit('update-drawer', false)
        }
    },
    watch:{
        mini(){
            this.$emit('change-mini', this.mini)
        },
        view(){
            this.setTabValue()
        }
    },
    mounted() {
        this.setTabValue()

        const { name } = this.$route
        this.tab = name
    },
}
</script>

<style scoped>
.h-100{
    height: 100%;
}
.logo{
    display: flex;
    height: 68px;
    width: 60px;
}
.v-tabs{
    position: absolute;
    height: 100%;
    width: 60px;
    left: 0;
    top: 0;
}
.v-tab{
    min-width: unset !important;
}
.v-tabs-items{
    margin-left: 60px;
    height: 100%;
}
.title{
    height: 22%;
}

.list-body{
    height: 65%;
    overflow-y: scroll;
    -ms-overflow-style: none; 
    scrollbar-width: none; 
}
.list-body::-webkit-scrollbar {
    display: none;
}

.active-plant{
    border-left: 5px solid var(--v-accent-base);
    border-right: 5px solid var(--v-accent-base);
    padding: 0px 10px;
    border-radius: 0px;
}
.name-plant{
    text-overflow: unset !important;
    white-space: unset !important;
}
.buttons-action{
    box-shadow: 0px 3px 16px 1px #0000005c;
    position: absolute;
    bottom: 0px;
    right: 0px;
    left: 0px;
    background-color: white;
}
</style>
